import * as React from 'react';
import { useButtonClassNames } from './hooks';
import { ButtonBaseProps } from './types';

export type ButtonAnchorProps = React.AnchorHTMLAttributes<HTMLAnchorElement> & ButtonBaseProps;

/**
 * Button that is rendered as an HTML anchor
 */
export const ButtonAnchor = React.forwardRef<HTMLAnchorElement, ButtonAnchorProps>(
	(
		{
			className,
			variant,
			size,
			isFullWidth,
			hasOnlyIcon,
			ctaGroupPos,
			children,
			hasNoPaddingX,
			hasNoStyles,
			noRadius,
			disabled,
			isLoading,
			...anchorProps // For passing props inherited from HTMLAnchorElement
		},
		ref,
	) => {
		const classes = useButtonClassNames(
			{
				variant,
				size,
				isFullWidth,
				hasOnlyIcon,
				ctaGroupPos,
				hasNoPaddingX,
				hasNoStyles,
				noRadius,
				disabled,
				isLoading,
			},
			className,
		);

		return (
			<a ref={ref} className={classes} {...anchorProps}>
				{children}
			</a>
		);
	},
);

ButtonAnchor.displayName = 'ButtonAnchor';
